import * as React from "react";
import BODebounceInput from "app/components/BOComponents/BODebounceInput";
import { Link } from "react-router-dom";

import { withApollo } from "react-apollo";
import gql from "graphql-tag";

import Popper from "@material-ui/core/Popper";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";

class SearchOutput extends React.Component<any, any> {
  render() {
    const usersList = () => {
      return this.props.user_data.map((val, key) => {
        return (
          <Link
            key={key}
            to={`/snapscan/ops/users/${val.external_reference}/payments`}
            onClick={this.props.closePopover}
            className="user-li"
          >
            <li>
              <h3 className="name-style">{val.email}</h3>
              <sub className="sub-style">user ({val.group})</sub>
            </li>
          </Link>
        );
      });
    };

    const merchantsList = () => {
      if (this.props.merchant_data.length > 0) {
        return this.props.merchant_data.map((val, key) => {
          return (
            <Link
              key={key}
              to={`/snapscan/ops/merchants/${val.id}/payments`}
              onClick={this.props.closePopover}
              className="merchant-li"
            >
              <li>
                <h3 className="name-style">{val.name}</h3>
                <sub className="sub-style">merchant #{val.id}</sub>
              </li>
            </Link>
          );
        });
      }
    };

    const renderValue = () => {
      if (this.props.loading) {
        return <i className="fa fa-spinner fa-spin fa-2x" />;
      } else if (
        this.props.merchant_data.length < 1 &&
        this.props.user_data.length < 1
      ) {
        return (
          <span>
            <i className="fa fa-exclamation-circle" /> No data found.
          </span>
        );
      } else {
        return (
          <div className="search-container">
            <ul className="search-ul">
              {usersList()}
              {merchantsList()}
            </ul>
          </div>
        );
      }
    };

    return (
      <Popper
        open={this.props.open}
        anchorEl={this.props.anchor}
        className="search-popover"
        disablePortal={true}
        style={{ backgroundColor: "#313d61", borderRadius: "5px" }}
      >
        {renderValue()}
      </Popper>
    );
  }
}

class BOSearch extends React.Component<any, any> {
  constructor(props: any) {
    super(props);

    this.state = {
      value: "",
      user_data: [],
      merchant_data: [],
      anchor: null,
      loading: false
    };

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(value: string, event: React.FormEvent<HTMLInputElement>) {
    this.setState({
      value: value.trim(),
      loading: true
    });
    if (value.trim() !== "") {
      this.props.client
        .query({
          query: gql`
            query getlist($search: String) {
              Users: users(search: $search, limit: 4) {
                email
                external_reference
                group
              }
              Merchants: merchants(search: $search, limit: 4) {
                name
                id
              }
            }
          `,
          variables: {
            search: value
          }
        })
        .then(({ data }) => {
          this.setState({
            user_data: [...data.Users],
            merchant_data: [...data.Merchants],
            loading: false
          });
        })
        .catch(error => {
          alert("There was an error trying to connect to the server." + error);
        });
    } else {
      this.setState({ user_data: [], merchant_data: [] });
    }
  }

  openPopover = (event: any) => {
    this.setState({
      anchor: event.currentTarget
    });
  };

  closePopover = () => {
    if (this.state.anchor) {
      this.setState({
        anchor: null
      });
    }
  };

  render() {
    return (
      <ClickAwayListener onClickAway={this.closePopover}>
        <div onFocus={this.openPopover}>
          <BODebounceInput
            minLength={2}
            debounceTimeout={300}
            placeholder="Search"
            onChange={this.handleChange}
            typeInput={true}
          />
          <SearchOutput
            open={!!this.state.anchor}
            anchor={this.state.anchor}
            closePopover={this.closePopover}
            loading={this.state.loading}
            merchant_data={this.state.merchant_data}
            user_data={this.state.user_data}
          />
        </div>
      </ClickAwayListener>
    );
  }
}

const BOSearchWithApollo = withApollo(BOSearch);
export default BOSearchWithApollo;
